export default {
  id: 213,
  title: 'Target #213 - Boat',
  url: 'https://cssbattle.dev/play/213',
  colors: ['#EEF8FF', '#4A7D7B', '#8AB8B6'],
  solution:
    '<p a><p b><p c><style>p[b],p[c]{border-style:solid}body{background:linear-gradient(#eef8ff 200px,#8ab8b6 200px)}p{position:fixed;margin:0}p[a]{bottom:75;left:0;width:100;height:50;background:#eef8ff;border-radius:100%;box-shadow:100px 0 #eef8ff,200px 0 #eef8ff,300px 0 #eef8ff}p[b]{top:32;left:200;border-width:70px 0 70px 100px;border-color:transparent #4a7d7b}p[c]{top:172;left:100;width:130;border-width:60px 35px 0;border-color:#4a7d7b transparent',
}
